import { render, staticRenderFns } from "./fullWhiteBg.vue?vue&type=template&id=2caf366e"
import script from "./fullWhiteBg.vue?vue&type=script&lang=js"
export * from "./fullWhiteBg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports